import { render, staticRenderFns } from "./productDataSummary.vue?vue&type=template&id=55ee2f7f&scoped=true"
import script from "./productDataSummary.vue?vue&type=script&lang=js"
export * from "./productDataSummary.vue?vue&type=script&lang=js"
import style0 from "./productDataSummary.vue?vue&type=style&index=0&id=55ee2f7f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ee2f7f",
  null
  
)

export default component.exports